import type { IOrderShareRequest } from '@/models/orders';
import { EmailServiceApiFactory, type ModelEmailData, type ModelEmailResponse } from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const emailServiceClient = () => {
  const client = createLayupClient();
  return EmailServiceApiFactory(undefined, undefined, client);
};

export const sendEmail = async (data: ModelEmailData): Promise<ModelEmailResponse> => {
  const response = await emailServiceClient().emailServiceSendEmail({
    modelEmailBody: { data },
  });
  return response.data;
};

export const sendReviewEmail = async (body: any): Promise<any> => {
  const client = createLayupClient(false);
  const response = await client.post('v1/emails', body);
  return response.data;
};

export const shareOrder = async (data: IOrderShareRequest) => {
  const client = createLayupClient(false);
  const response = await client.post('v1/emails', data);
  return response.data;
};
